<template>
  <div id="app">
    <div v-if="wechatCallbackProcessing" class="wechat-callback-overlay">
      <span>正在处理微信登录...</span>
    </div>
    <router-view v-else />
  </div>
</template>

<script>
import { getOpenIdByCode, bindWxOpenId } from '@/api/user'

export default {
  name: 'App',
  data() {
    return {
      wechatCallbackProcessing: false
    }
  },
  mounted() {
    this.handleWechatCallback()
  },
  methods: {
    getCodeFromUrl() {
      const search = window.location.search || ''
      const hash = window.location.hash || ''
      const fromSearch = search.match(/[?&]code=([^&]+)/)
      const fromHash = hash.match(/[?&]code=([^&]+)/)
      const match = fromSearch || fromHash
      return match ? decodeURIComponent(match[1]) : ''
    },
    async handleWechatCallback() {
      const code = this.getCodeFromUrl()
      if (!code) return
      // 在 iframe 中或主窗口：扫码回调，用 code 换 openID 并绑定
      const isInIframe = window.self !== window.top
      if (!isInIframe) {
        this.wechatCallbackProcessing = true
      }
      try {
        const res = await getOpenIdByCode({ code })
        if (res.code !== 1 || !res.data?.openid) {
          throw new Error(res.msg || '获取 openid 失败')
        }
        const openid = res.data.openid
        const bindRes = await bindWxOpenId({ openid, openType: 1 })
        if (bindRes.code !== 1) {
          throw new Error(bindRes.msg || '绑定失败')
        }
        if (isInIframe) {
          window.parent.postMessage({ type: 'wechat-scan-success' }, '*')
        } else {
          this.$root.$emit('wechat-scan-success')
        }
      } catch (e) {
        console.error('微信登录回调失败:', e)
        if (this.$message && this.$message.error) {
          this.$message.error(e?.message || '处理失败，请重试')
        }
      } finally {
        this.wechatCallbackProcessing = false
        let clean = window.location.pathname + (window.location.hash || '#/')
        clean = clean.replace(/[?&]code=[^&]*/g, '').replace(/[?&]state=[^&]*/g, '').replace(/\?&+|\?$|&$/g, '')
        window.history.replaceState(null, '', clean || '/')
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  width: 100%;
  height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.el-pagination.is-background .el-pager li{
  background: #fff !important;
  border: 1px solid #eee !important;
  color: #333 !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: #fff6af !important;
    color: #333 !important;
}
.el-pagination.is-background .btn-prev{
  background: none !important;
}
.el-pagination.is-background .btn-next{
  background: none !important;
}
/* 覆盖 common.scss 中 img 的 pointer-events:none，使可点击的图片生效 */
img.clickable {
  pointer-events: auto !important;
  cursor: pointer;
}

/* 全局样式 - 放在 App.vue 的 style 标签中（不加 scoped） */
.el-cascader-panel {
  height: 400px !important;
}

.el-cascader-menu__wrap {
  height: 100% !important;
}

/* 或者更精确地设置 */
.el-cascader__dropdown .el-cascader-panel {
  height: 400px !important;
}

.el-cascader__dropdown .el-cascader-menu {
  height: 100% !important;
}

.el-cascader__dropdown .el-cascader-menu__wrap {
  height: 100% !important;
}

/* 全局禁用 ElementUI 文本域拖拽大小 */
.el-textarea__inner {
  resize: none !important;
}

/* 微信扫码回调处理中 */
.wechat-callback-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-size: 16px;
  color: #333;
}
</style>
